import React from 'react';

import InputRange from '../../shared/InputRange';

const STEP = 25;

const nextUp = (value, step) => {
  const mod = value % step;
  const delta = step - mod;
  return value + delta;
};

const nextDown = (value, step) => {
  const result = nextUp(value, step) - step;
  return result >= 0 ? result : 0;
};

const boundedValues = (bounds, step) => ({
  min: nextDown(bounds.min, step),
  max: nextUp(bounds.max, step),
});

export const SimplePossessionsFilter = ({
  possessions,
  bounds,
  onChange,
  disabled,
}) => (
  <div className="filter-container condensed">
    <div className="filter">
      <div className="form-row">
        <div className="form-column--xs">
          <div className="form-group">
            <label>Possessions</label>
            {bounds && (
              <InputRange
                value={
                  possessions.min && possessions.max
                    ? boundedValues(possessions, STEP)
                    : boundedValues(bounds, STEP)
                }
                minValue={0}
                maxValue={nextUp(bounds.max, STEP)}
                onChange={onChange}
                disabled={disabled}
                step={possessions.max > bounds.max ? 1 : STEP}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);
